import { call, all, put, takeEvery } from 'redux-saga/effects';
import {
  getAssessmentReportSuccessAction,
  getAssessmentReportFailureAction,
  getAssessmentDetaisReportSuccessAction,
  getAssessmentDetaisReportFailureAction,
  getAssessmentExportFileSuccessAction,
  getAssessmentExportFileFailureAction,
  getAssessmentUserReportSuccessAction,
  getAssessmentUserReportFailureAction,
  getAssessmentUserExportFileSuccessAction,
  getAssessmentUserExportFileFailureAction
} from '../../features/Reports/assessmentReportSlice';
import URLs from '../../../constants/urls';
import { GET_ASSESSMENT_REPORT_TABLE_DATA,GET_ASSESSMENT_DETAILS_REPORT_DATA,GET_ASSESSMENT_EXPORT_FILE,GET_ASSESSMENT_USER_REPORT_DATA,GET_ASSESSMENT_USER_EXPORT_FILE } from '../../actions/Reports/actionAssessmentType';
import { apiPython } from '../../../service/api';
const api = apiPython;
import { getSessionStorage } from '../../../utils/helpers';

export function* getAssessmentDetailsReportSaga({ payload: data }) {
  const skillId = data['skillId']
  try {
    if(skillId > 0){
      const response = yield api.get(`${URLs.GET_ASSESSMENT_SKILL_BASED_REPORT}?cycleId=${data['id']}&cycleName=${data['name']}&skillId=${skillId}&loggedUserID=${getSessionStorage('USER_ID')}`);
      yield put(getAssessmentDetaisReportSuccessAction(response.data.data));
    }else{
      const response = yield api.get(`${URLs.GET_ASSESSMENT_DETAILS_REPORT}?cycleId=${data['id']}&cycleName=${data['name']}&loggedUserID=${getSessionStorage('USER_ID')}`);
      yield put(getAssessmentDetaisReportSuccessAction(response.data.data));
    }
  } catch (error) {
    yield put(getAssessmentUserReportFailureAction(error));
  }
}

export function* getAssessmentUserReportSaga({ payload: data }) {
  const skillId = data['skillId']
  try {
    if(skillId > 0){
      const response = yield api.get(`${URLs.GET_ASSESSMENT_USER_REPORT}?id=${data['id']}&s=${data['skillId']}&loggedSamID=${getSessionStorage('USER_ID')}&permissionLevel=${getSessionStorage('PERMISSION_LEVEL')}`);
      yield put(getAssessmentUserReportSuccessAction(response.data.data));
    }else{
      const response = yield api.get(`${URLs.GET_ASSESSMENT_USER_REPORT}?id=${data['id']}&loggedSamID=${getSessionStorage('USER_ID')}&permissionLevel=${getSessionStorage('PERMISSION_LEVEL')}`);
      yield put(getAssessmentUserReportSuccessAction(response.data.data));
    }
  } catch (error) {
    yield put(getAssessmentDetaisReportFailureAction(error));
  }
}




export function* getAssessmentReportListSaga({ payload: data }) {
  try {
    const response = yield api.get(`${URLs.GET_ASSESSMENT_CYCLES_REPORT}?type='external'&permissionlevel=${getSessionStorage('PERMISSION_LEVEL')}`);
    yield put(getAssessmentReportSuccessAction(response.data.data));
  } catch (error) {
    yield put(getAssessmentReportFailureAction(error));
  }
}
export function* getAssessmentExportFileSaga({ payload: data }) {
  const skillId = data['skillId']
  try {
    if(skillId > 0){
      const response = yield api.get(`${URLs.GET_ASSESSMENT_SKILL_BASED_EXPORT}?cycleId=${data['id']}&cycleName=${data['name']}&skillId=${skillId}&loggedUserID=${getSessionStorage('USER_ID')}`);
      yield put(getAssessmentExportFileSuccessAction(response.data.data));
    }else{
      const response = yield api.get(`${URLs.GET_ASSESSMENT_DETAILS_EXPORT}?cycleId=${data['id']}&cycleName=${data['name']}&loggedUserID=${getSessionStorage('USER_ID')}`);
      yield put(getAssessmentExportFileSuccessAction(response.data.data));
    }
  } catch (error) {
    yield put(getAssessmentExportFileFailureAction(error));
  }
}

export function* getAssessmentExportUserFileSaga({ payload: data }) {
  const skillId = data['skillId'] ==0?'': data['skillId']
  try {
      const response = yield api.get(`${URLs.GET_ASSESSMENT_USER_BASED_EXPORT}?id=${data['id']}&s=${skillId}&loggedSamID=${getSessionStorage('USER_ID')}&permissionlevel=${getSessionStorage('PERMISSION_LEVEL')}`);
      yield put(getAssessmentUserExportFileSuccessAction(response.data.data));
  } catch (error) {
    yield put(getAssessmentUserExportFileFailureAction(error));
  }
}
export function* watchAssessmentReport() {
  yield takeEvery(GET_ASSESSMENT_EXPORT_FILE, getAssessmentExportFileSaga);
  yield takeEvery(GET_ASSESSMENT_DETAILS_REPORT_DATA, getAssessmentDetailsReportSaga);
  yield takeEvery(GET_ASSESSMENT_REPORT_TABLE_DATA, getAssessmentReportListSaga);
  yield takeEvery(GET_ASSESSMENT_USER_REPORT_DATA, getAssessmentUserReportSaga);
  yield takeEvery(GET_ASSESSMENT_USER_EXPORT_FILE, getAssessmentExportUserFileSaga);
  
}

export default function* assessmentReportSaga() {
  yield all([watchAssessmentReport()]);
}
